import { api } from "./axios";

class CourseService {
  async auth(auth) {
    const { data } = await api.post("/auth", auth);
    return data;
  }

  async saveCourse(course) {
    const response = await api.post("/courses", course);

    return response.data.id;
  }

  uploadFiles(body) {
    return api.post("/files/base64", body);
  }

  async uploadFile(base64, name, refId) {
    await api.post("/files/base64", {
      id: refId,
      documents: [
        {
          key: "image-course",
          base64: base64,
          name: "avatar",
        },
      ],
      typeRef: "course",
    });
  }

  getCourse() {
    return api.get("/courses");
  }

  searchCourses(page, perPage, name) {
    return api.get(`/courses?page=${page}&perPage=${perPage}&name=${name}`);
  }

  comboboxCourses() {
    return api.get("/courses/list/combobox");
  }

  async fillComboBoxWithPaginate(id = '', text = '', page) {
    const { data } = await api.get(
      `/customers/combobox/with/paginate?id=${id}&q=${encodeURIComponent(text)}&page=${page}`
    );

    return data
  }

  comboboxStudents() {
    return api.get("/students/list/combobox");
  }

  finishCourse(courseId) {
    return api.get(`/student/course/finishe-course/${courseId}`);
  }

  startCourse(courseId) {
    return api.get(`/student/course/start-course/${courseId}`);
  }

  reiniciarCurso(courseId) {
    return api.get(`/student/course/reset-course/${courseId}`);
  }

  allStudentTheCourse(courseId) {
    return api.get(`/courses/students/${courseId}`);
  }

  getCountCourse() {
    return api.get("/documents-approveds/count/status");
  }

  getCourseId(id) {
    return api.get(`/courses/${id}`);
  }

  updateCourse(course, id) {
    return api.put(`/courses/${id}`, course);
  }

  usersById(id) {
    return api.post(`/users/${id}`);
  }

  getUsersById(id) {
    return api.post(`/users/${id}`);
  }

  allStudentCourse() {
    return api.get("/documents-approveds");
  }

  getStudentById(id) {
    return api.get(`/students/${id}`);
  }

  getAllStudents(page) {
    return api.get(`/students?page=${page}`);
  }

  getStudentBy(typeSearch, search, page, limit) {
    return api.get(
      `/students?${typeSearch}=${search}&page=${page}&limit=${limit}`,
    );
  }

  getAllUsers() {
    return api.get("/users");
  }

  getUsersId(id) {
    return api.get(`/users/${id}`);
  }

  getUserCount() {
    return api.get("/users/report/count");
  }

  getStudentStatus(status, typeSerach, search) {
    let pathRequest = `/documents-approveds?status=${status}`;
    if (typeSerach && search) {
      pathRequest = `${pathRequest}&${typeSerach}=${search}`;
    }
    return api.get(pathRequest);
  }

  saveUsers(users) {
    return api.post("/users", users);
  }

  updateUsers(users, id) {
    return api.put(`/users/${id}`, users);
  }

  deleteCourse(id) {
    return api.delete(`/courses/${id}`);
  }

  deleteRegistration(id) {
    return api.delete(`/student/course/${id}`);
  }

  async downloadFiles(refId, fileType, typeRef) {
    const response = await api.get(
      `/files/download?refId=${refId}&fileType=${fileType}&typeRef=${typeRef}`,
    );

    const link = document.createElement("a");
    link.href = response.data.url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getFiles(refId, typeRef) {
    return api.get(`/files?refId=${refId}&typeRef=${typeRef}`);
  }

  updateDocuments(documents, idStudent, courseId) {
    return api.put(`/documents-approveds/${idStudent}/${courseId}`, documents);
  }

  updateStudents(body, idStudent) {
    return api.put(`/students/${idStudent}`, body);
  }

  saveContract(contract) {
    return api.post("/contracts", contract);
  }

  getContractByCourse(studentId, courseId) {
    return api.get(`/contracts/${studentId}/${courseId}`);
  }

  getContract(courseId) {
    return api.get(`/contracts/${courseId}`);
  }

  updateContract(courseId, contract) {
    return api.put(`/contracts/${-1}/${courseId}`, { data: contract });
  }

  updateVinculoContract(courseId, studentId, contract) {
    return api.put(`/contracts/${courseId}/${studentId}`, { data: contract });
  }

  updateCourseStudentContract(contract) {
    return api.put(`/contracts/${contract.studentId}/${contract.courseId}`, {
      data: contract.data,
    });
  }

  getContractData(idStudent) {
    return api.get(`/students/${idStudent}`);
  }

  updateResponsible(responsible) {
    return api.put(`/responsible/${responsible.id}`, responsible);
  }

  updateBondsman(bondsman) {
    return api.put(`/bondsman/${bondsman.id}`, bondsman);
  }
}

export default new CourseService();
